import { useEffect, useState } from 'react';
import { Grid, TextField } from '@material-ui/core';
import { css } from '@emotion/react';
import {
    ResponsiveSidebarDialog,
    ModalTitle,
    ModalContent,
    StickyModalActions,
    SecondaryButton,
    PrimaryButton,
} from '@/styles/blocks';

const DeliveryProfileModal = ({ open, onClose, deliveryProfile, callbacks }) => {
    const isEdit = !!deliveryProfile?.delivery_profile_id;
    const [name, setName] = useState('');

    useEffect(() => {
        if (open) {
            setName(deliveryProfile?.name || '');
        }
    }, [open, deliveryProfile?.delivery_profile_id]);

    const onSave = async () => {
        await callbacks.upsertDeliveryProfile({
            delivery_profile_id: deliveryProfile?.delivery_profile_id,
            name,
        });
        onClose();
    };

    return (
        <ResponsiveSidebarDialog open={open} onClose={onClose}>
            <ModalTitle title={isEdit ? 'Edit Delivery Profile' : 'Create Delivery Profile'} onClose={onClose} />
            <ModalContent>
                <Grid
                    container
                    direction="column"
                    css={css`
                        gap: 16px;
                    `}
                >
                    <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Delivery Profile Name"
                        value={name || ''}
                        InputLabelProps={{ shrink: !!name }}
                        onChange={(e) => setName(e.target.value)}
                    />
                </Grid>
            </ModalContent>
            <StickyModalActions>
                <Grid item>
                    <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                </Grid>
                <Grid item>
                    <PrimaryButton onClick={onSave}>Save</PrimaryButton>
                </Grid>
            </StickyModalActions>
        </ResponsiveSidebarDialog>
    );
};

export default DeliveryProfileModal;
